import { render, staticRenderFns } from "./sluserinvite.vue?vue&type=template&id=c7f22950&"
import script from "./sluserinvite.vue?vue&type=script&lang=js&"
export * from "./sluserinvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports